import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { DistrictEntity } from "../district/district.entity";
import { EventsEntity } from "../event/event.entity";
import { MandalEntity } from "../mandal/mandal.entity";
import { ProfileEntity } from "../profile/profile.entity";
import { StatesEntity } from "../states/states.entity";
@Entity('village')
export class VillageEntity {

  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("varchar",{
    nullable:false,
    length:500,
    name:"village_name"
  })
  villageName:string;
  @Column("int",{
    nullable:true,
    name:"mandal_id"
  })
  mandalId: number;
  // @Column("int",{
  //   nullable:false,
  //   name:"district_id"
  // })
  // districtId:number;
  // @Column('int',{
  //   nullable : true,
  //   name:"state_id"
  // })
  // stateId:number;
  @Column("boolean",{
    nullable:false,
    default:true,
    name:"status"
  })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;
  @Column("int", {
    nullable: false,
    name: "created_user"
  })
  createdUser: number | null;
  @UpdateDateColumn({
    name: "updated_at",
    type:'datetime'
  })
  updatedAt: Date;
  @Column("int", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: number | null;
  @VersionColumn({
    default:1,
    name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(() => MandalEntity,(mandal: MandalEntity) =>mandal.village)
  @JoinColumn({name : 'mandal_id'})
  mandal: MandalEntity;

  // @ManyToOne(() => DistrictEntity, (district: DistrictEntity) => district.village)
  // @JoinColumn({name : 'district_id'})
  // district: DistrictEntity;
  
  @OneToMany(() => EventsEntity, (event: EventsEntity) => event.village)
  event:EventsEntity;

  @OneToMany(() => ProfileEntity, (profile: ProfileEntity) => profile.village)
  profile:ProfileEntity;
    
  // @ManyToOne(() => StatesEntity,(states: StatesEntity) => states.village)
  // @JoinColumn({name: 'state_id'})
  // states: StatesEntity; 
}
